import { post } from "../../../shared/data";

export const resubmitTask = (taskKeys, destinationKeys, updatePostDate, sendToGdsn) => {
    // {
    //     "items": [
    //         {
    //         "destinationKeys": "string[]",
    //         "taskContextKey": "string"
    //         "updatePostDate": "bool"
    //         "sendToGdsn": "bool"
    //         }
    //     ]
    // }
    const payload = {
        items: taskKeys.map((taskKey) => {
            return { taskContextKey: taskKey, destinationKeys: destinationKeys, updatePostDate: updatePostDate, sendToGdsn };
        }),
    };

    return post("/admin/resubmit", payload, {noRedirect: true});
};

export const getProducts = (upcs) => {
    const payload = {
        items: upcs,
    };

    return post("/tasking/contexts/search", payload).then((response) => {
        return response.reduce((data, u) => {
            if (u.isFinalized) {
                data.push({ ...u, shouldSubmit: true });
            }

            return data;
        }, []);
    });
};
